import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var StyledKPortal = styled(Box, {
    shouldForwardProp: function (prop) {
        return prop !== "gridColumnSize" &&
            prop !== "gridLargeColumnSize" &&
            prop !== "cardCount" &&
            prop !== "firstLarger";
    }
})(function (_a) {
    var _b;
    var theme = _a.theme, gridColumnSize = _a.gridColumnSize, gridLargeColumnSize = _a.gridLargeColumnSize, firstLarger = _a.firstLarger, cardCount = _a.cardCount;
    return (_b = {
            display: "grid",
            /* Center grid in root container */
            justifyContent: "center",
            "& > :first-child": {
                /* Add larger gap between first large card and smallest one */
                marginRight: function (props) {
                    return props.firstLarger && props.cardCount <= 4 ? theme.spacing(4) : "0";
                }
            },
            gridTemplateColumns: getGridTemplateColumns({
                breakpointDown: null,
                gridColumnSize: gridColumnSize,
                gridLargeColumnSize: gridLargeColumnSize,
                firstLarger: firstLarger,
                cardCount: cardCount
            })
        },
        _b[theme.breakpoints.down("lg")] = {
            gridTemplateColumns: getGridTemplateColumns({
                breakpointDown: "lg",
                gridColumnSize: gridColumnSize,
                gridLargeColumnSize: gridLargeColumnSize,
                firstLarger: firstLarger,
                cardCount: cardCount
            }),
            "& > :first-child": {
                /* No margin as first large card will be on a full row */
                marginRight: "0",
                /* Large card on first row */
                gridColumn: firstLarger && cardCount <= 4 ? "".concat(cardCount - 1, " span") : "auto"
            }
        },
        _b[theme.breakpoints.down("sm")] = {
            /* Full width for cards */
            gridTemplateColumns: "1fr",
            "& > :first-child": {
                marginRight: "0",
                gridColumn: "auto"
            }
        },
        _b.gap = theme.spacing(4),
        _b);
});
function getGridTemplateColumns(_a) {
    var breakpointDown = _a.breakpointDown, gridColumnSize = _a.gridColumnSize, gridLargeColumnSize = _a.gridLargeColumnSize, cardCount = _a.cardCount, firstLarger = _a.firstLarger;
    // generic
    var columnSize = gridColumnSize || "minmax(10rem, 20rem)";
    var largeColumnSize = gridLargeColumnSize || "minmax(20rem, 30rem)";
    if (breakpointDown === "lg") {
        // Compute columns to avoid orphans
        if (firstLarger && cardCount === 1) {
            // Having a lonely large card
            return "".concat(largeColumnSize);
        }
        else if (firstLarger && cardCount === 2) {
            // First large card then small one
            return "".concat(largeColumnSize, "  ").concat(columnSize);
        }
        else if (firstLarger && cardCount <= 4) {
            // Columns for small cards
            return "repeat(".concat(cardCount - 1, ", ").concat(columnSize, ")");
        }
        else {
            // Compute optimal columns to avoid orphans
            return "repeat(".concat(computeSmColumns(cardCount), ", ").concat(columnSize, ")");
        }
    }
    else {
        // Compute columns to avoid orphans
        if (cardCount <= 8) {
            if (firstLarger && cardCount === 1) {
                // Having a lonely large card
                return "".concat(largeColumnSize);
            }
            else if (firstLarger && cardCount <= 4) {
                // First large card then small cards
                return "".concat(largeColumnSize, " repeat(").concat(cardCount - 1, ", ").concat(columnSize, ")");
            }
            else {
                // Compute optimal columns to avoid orphans
                return "repeat(".concat(computeColumns(cardCount), ", ").concat(columnSize, ")");
            }
        }
        // Grid default auto-fit
        return "repeat(auto-fit, ".concat(columnSize, ")");
    }
}
function computeColumns(cardCount) {
    switch (cardCount) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
        case 5:
        case 6:
            return 3;
        default:
            return 4;
    }
}
function computeSmColumns(cardCount) {
    switch (cardCount) {
        case 1:
            return 1;
        case 3:
            return 3; // avoid orphan
        default:
            return 2;
    }
}

export { StyledKPortal as default };
//# sourceMappingURL=index.styled.js.map
